import { getAllSocialLinkRequest } from "../repositories/social_repository";

export const SocialService = () => {
    const fetchAllSocial = async (setSocialList) => {
        try {
            const response = await getAllSocialLinkRequest();
            if (response?.success) {
                setSocialList(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch social links.");
        }
    };

    return {
        fetchAllSocial,
    };
};